import projects from '../database/projects'

const getProjects = () => {
  return projects;
}

export default getProjects;